// src/pages/ContentEditor/components/tabs/DecodeWordsTab.js
import React from 'react';
import { Box, Typography, Button, Card, CardContent, IconButton, TextField, Grid, alpha } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const DecodeWordsTab = ({ words, onNestedChange, onAddItem, onRemoveItem }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" color="text.primary">
          Decode Words
        </Typography>
        
        <Button
          startIcon={<AddIcon />}
          onClick={onAddItem}
          sx={{ color: theme.palette.primary.main }}
        >
          Add Word
        </Button>
      </Box>
      
      <Grid container spacing={2}>
        {words.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card 
              variant="outlined"
              sx={{ 
                backgroundColor: theme.palette.background.paper,
                borderColor: alpha(theme.palette.common.white, 0.1),
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                }
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle2" fontWeight={500} color="text.primary">
                    Word {index + 1}
                  </Typography>
                  
                  <IconButton 
                    size="small"
                    color="error" 
                    onClick={() => onRemoveItem(index)}
                    disabled={words.length <= 1}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
                
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Enter word..."
                  value={item.word.text}
                  onChange={(e) => onNestedChange('decodeActivity', index, 'word', e.target.value)}
                  InputProps={{ style: { color: theme.palette.text.primary } }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: alpha(theme.palette.common.white, 0.2),
                      },
                      '&:hover fieldset': {
                        borderColor: alpha(theme.palette.common.white, 0.3),
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: theme.palette.primary.main,
                      },
                      backgroundColor: alpha(theme.palette.common.white, 0.05)
                    }
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DecodeWordsTab;